module.exports = __webpack_public_path__ + "images/grupo_IDHouse_mobile.559a791b.png";